// extracted by mini-css-extract-plugin
export default {"armyTray":"ArmyTray_armyTray__FXipA","darkOverlay":"ArmyTray_darkOverlay__2-5o4","scrollArea":"ArmyTray_scrollArea__aS+GD"};